import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { ShareObjectsController } from '@commoncore/controller/ShareObjectsController';
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents } from '@commoncore/utils/app-events';

@Component({
  standalone:true,
  selector: 'app-share-discard',
  templateUrl: './share-discard.component.html',
  styleUrls: ['./share-discard.component.scss'],
  imports:[CommonModule]
})
export class ShareDiscardComponent implements OnInit {

  // @Output() close = new EventEmitter();
  @Output() close = new EventEmitter();
  @Output() confirmDeletion = new EventEmitter();
  universalService: any;
  controller: any;
  implRef: any;
  listService: any;
  shareAccessService: any;

  constructor(public globalService: GlobalService) {
    this.setEnvObjects(globalService);
  }
  
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      //this.listService.deSelectAll(event)
      this.closePopUp();
    }else if(event.key === "Enter"){
      this.discardShare()
    }
  }

  ngOnInit(): void {
    this.controller=ShareObjectsController.getInstance(this.globalService);
    this.controller.setEnvObjects(this.globalService);
    this.implRef = this.controller.shareObjectsImplementation;
    this.controller.setEnvObjects(this.globalService);
  }

  setEnvObjects(globalService) {
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
  }

  closePopUp(){
    //this.close.emit();
    let ele = document.querySelector('.add-member-panel') as any;
    if(!ele) {
      ele = document.querySelector('.add-people-panel') as any;
    }
    setTimeout(()=>{
      ele.style.zIndex = '9999';
      this.universalService.showModalBackdrop();
      this.universalService.popUpToBeOpened = '';
    },200)
  }

  discardShare() {
    var self = this;
    // if(this.universalService.currentTab == 'addpeople' && this.universalService.inAppWebViewOpened){
    //   this.universalService.currentTab = "";
    // }
    //this.close.emit();
    this.universalService.popUpToBeOpened = '';
    this.universalService.isAnyChange = false;
    this.universalService.disableModalBackdrop();
    this.listService.deSelectAll(""); 
    if(this.universalService.inAppWebViewOpened) {
      setTimeout(function(){
        self.universalService.showShareWithPeople = false;
        self.universalService.loadManageAccessComponent = false;
        AppEvents.optionSelected.next({shareWithPeople: false});
        // self.universalService.showFileInfo = false;
        self.universalService.showEnhancedShareLink = false;
        self.implRef.resetDefaultProperties();
      }, 500);
    } else {
      jQuery(".add-people-panel").animate({"right":"-1000px"}, "400");
      jQuery(".add-member-panel").animate({"right":"-1000px"}, "400");
      self.universalService.showShareWithPeople = false;
      self.universalService.loadManageAccessComponent = false;
      self.universalService.showFileInfo = false;
      self.universalService.showEnhancedShareLink = false;
      this.implRef.resetDefaultProperties();
    }
   
  }
}
